/** @jsx jsx */
import { Container, Flex, Heading } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { fetchSimilarJobRequests } from "@/data/job-requests";
import { useFetcher } from "@/hooks/http";
import { SimilarJobTile } from "@/views/job-requests/_components/SimilarJobs/SimilarJobTile";

interface SimilarJobsTilesProps {
  jobRequestId: number;
}

export const SimilarJobsTiles: FC<SimilarJobsTilesProps> = ({ jobRequestId }) => {
  const { t } = useTranslation("session");

  const { payload } = useFetcher(fetchSimilarJobRequests, { jobRequestId }, [jobRequestId]);

  if (!payload || payload.numberOfElements < 2) {
    return null;
  }

  return (
    <Container>
      <Flex flexDirection="column" gap="sm">
        <Heading size="h-sm" align="center">
          {t("JOB_REQUESTS.APPLY.WIZARD.EXPLORE_MORE_JOBS")}
        </Heading>
        <Flex gap="sm" justifyContent="center">
          {payload.content.map(jr => (
            <Flex flexGrow={1} sx={{ maxWidth: 304 }} key={jr.id}>
              <SimilarJobTile jobRequest={jr} />
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Container>
  );
};
